import { Box, Flex, Image, Text } from "@chakra-ui/react";

function IconTitle({ title, subTitle, icon }) {
  return(
    <Flex gap="5" inlineSize="305px">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexShrink="0"
        inlineSize="8"
        blockSize="8"
        padding="1"
        borderWidth={icon ? "thin" : ""}
        borderRadius={icon ? "md" : ""}>
        {icon && <Image src={icon} />}
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        fontSize="sm"
        whiteSpace="break-spaces">
        <Text>
          <b>{title}</b>{subTitle ? subTitle : ""}
        </Text>
      </Box>
    </Flex>
  );
}

export default IconTitle;